/*
 * @Author: 丨小小风离丨
 * @Date: 2024-03-04 08:46:45
 * @LastEditTime: 2024-05-30 17:03:48
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\contact\index.tsx
 * @Description: 
 */
import { useSelector } from 'react-redux';
import { selectAboutUs } from '../../store/reducers/schoolInfo';
import './index.scss';

function Contact() {
    const aboutUs = useSelector(selectAboutUs);
    return (
        <div className="contact">
            {aboutUs?.map((ele, index) => {
                let iconType = ""
                switch (ele.iconType) {
                    case "-1": iconType = "adress"; break;
                    case "-2": iconType = "phone"; break;
                    case "-3": iconType = "email"; break;
                    case "-4": iconType = "app"; break;
                    default: iconType = ''; break;
                }
                return <div className='contact_icon' key={index}>
                    {iconType ?
                        <div className={`contact_icon_content_icon ${iconType}`}></div> :
                        <img src={ele?.resources?.url || ele?.resources?.preUrl} className='contact_icon_content_icon' />
                    }
                    <div className='contact_icon_content_title'>{ele?.name}</div>
                    <div
                        className='contact_icon_content_desc'
                        style={{ cursor: ele?.type === 2 ? 'pointer' : null }}
                        onClick={() => {
                            if (ele?.type === 2) {
                                window.open(ele?.content)
                            }
                        }}
                    >{ele?.content}</div>
                </div>
            })}
        </div>
    )
}

export default Contact
